import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);

  canActivate() {
    return this.userService.hasAdminAccess().pipe(
      take(1),
      map((hasAdminAccess: boolean) => {
        if (hasAdminAccess) {
          return true;
        } else {
          this.router.navigate(['/home'], {
            queryParamsHandling: 'merge'
          });
          return false;
        }
      })
    );
  }
}
